import React from "react";
import "../../pages/Beneficiary/styles/BeneficiaryList.css";

const Table = ({ columns, data }) => {
  return (
    <div className="super-git-table !p-0 !m-0">
      <table className="table-super-git !p-0">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.dataKey} className="px-4 py-2">
                {column.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              {columns.map((column) => (
                <td key={column.dataKey} className="border px-4 py-2">
                  {row[column.dataKey]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
